// As strings do voucher de mobilidade (a corrida, `buildMobilityVoucherView`, #5029), em
// arquivo próprio pelo mesmo motivo do `hotel_voucher_catalog.ts`: o catálogo principal tem
// teto de 500 linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.mobilityVoucher.title': 'Mobilidade',
  'trips.mobilityVoucher.dates': 'Corrida · {{date}}',
  'trips.mobilityVoucher.ride': 'Corrida',
  'trips.mobilityVoucher.rideBy': 'Corrida {{supplier}}',
  'trips.mobilityVoucher.completed': 'Concluída',
  'trips.mobilityVoucher.completedOn': 'Concluída em {{date}}',
  'trips.mobilityVoucher.estimated': 'Estimado na solicitação',
  'trips.mobilityVoucher.charged': 'Cobrado',
  'trips.mobilityVoucher.difference': 'Diferença de {{amount}} em relação ao teto estimado.',
  'trips.mobilityVoucher.options': 'Opções apresentadas',
  'trips.mobilityVoucher.categories_one': '{{count}} categoria',
  'trips.mobilityVoucher.categories_other': '{{count}} categorias',
  'trips.mobilityVoucher.proof': 'Comprovante',
  'trips.mobilityVoucher.receipt': 'Recibo da corrida',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.mobilityVoucher.title': 'Mobility',
  'trips.mobilityVoucher.dates': 'Ride · {{date}}',
  'trips.mobilityVoucher.ride': 'Ride',
  'trips.mobilityVoucher.rideBy': '{{supplier}} ride',
  'trips.mobilityVoucher.completed': 'Completed',
  'trips.mobilityVoucher.completedOn': 'Completed on {{date}}',
  'trips.mobilityVoucher.estimated': 'Estimated at request',
  'trips.mobilityVoucher.charged': 'Charged',
  'trips.mobilityVoucher.difference': '{{amount}} above the estimated ceiling.',
  'trips.mobilityVoucher.options': 'Options presented',
  'trips.mobilityVoucher.categories_one': '{{count}} category',
  'trips.mobilityVoucher.categories_other': '{{count}} categories',
  'trips.mobilityVoucher.proof': 'Receipt',
  'trips.mobilityVoucher.receipt': 'Ride receipt',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.mobilityVoucher.title': 'Movilidad',
  'trips.mobilityVoucher.dates': 'Viaje · {{date}}',
  'trips.mobilityVoucher.ride': 'Viaje',
  'trips.mobilityVoucher.rideBy': 'Viaje {{supplier}}',
  'trips.mobilityVoucher.completed': 'Concluido',
  'trips.mobilityVoucher.completedOn': 'Concluido el {{date}}',
  'trips.mobilityVoucher.estimated': 'Estimado en la solicitud',
  'trips.mobilityVoucher.charged': 'Cobrado',
  'trips.mobilityVoucher.difference': 'Diferencia de {{amount}} respecto al tope estimado.',
  'trips.mobilityVoucher.options': 'Opciones presentadas',
  'trips.mobilityVoucher.categories_one': '{{count}} categoría',
  'trips.mobilityVoucher.categories_other': '{{count}} categorías',
  'trips.mobilityVoucher.proof': 'Comprobante',
  'trips.mobilityVoucher.receipt': 'Recibo del viaje',
};

export const MOBILITY_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
